import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const dry: ImportTypeConfig = {
  type: 'dry',
}
